import { render, staticRenderFns } from "./EditDownloadCategoryPage.vue?vue&type=template&id=1baec1da&"
import script from "./EditDownloadCategoryPage.vue?vue&type=script&lang=js&"
export * from "./EditDownloadCategoryPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports